/*========================================================================
 * $Id: resources.js 90842 2016-05-24 16:46:05Z jakob.praher $
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2015
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define([
    "client/sourceinfo",
    "i18n/i18n",
    "api/v2/common",
    "backbone",
    "underscore",
    "model/tree",
    "model/readonlytree",
    "model/persisted_collection",
    "service/stub",
    "service/factory",
    "service/channels"

  ],

  function(
    SourceInfo,
    i18n,
    Common,
    Backbone,
    _,
    TreeModel,
    ReadOnlyTreeModel,
    PersistedCollection,
    Stub,
    ServiceFactory,
    Channels
  ){
  // TODO: use messageframe instead

  var PersistedResourcesServiceStub = Stub.extend({
    path: "persistedresources"
  });

  var PersistedCollectionsServiceStub = Stub.extend({
    path: "persistedcollections"
  });

  var PersistedCollectionSchemaServiceStub  = Stub.extend({
    path: "persistedcollectionschema"
  });


  var PersistedResourceModel = PersistedCollection.Model.extend({
    parse: function (atts) {
      // console.log("parse");
      var result = _.extend({}, atts);
      var props = {};
      if (_.isArray(atts && atts.property)) {
        props.properties = _.reduce(atts.property, function(properties, p) {
          properties[p.key] = p.value;
          return properties;
        }, {});
        delete result.property;
      }
      if ((!atts || !atts.id) && (atts && atts.path)) {
        props.id = atts.path.join("/");
      }

      return _.extend({}, result, props);
    },

    toJSON: function(options) {
      // console.log("toJSON");
      var atts = _.clone(this.attributes);
      if (atts.properties && _.isObject(atts.properties)) {
        var result = [];
        var keys = _.keys(atts.properties);
        for (var i = 0; i < keys.length; ++i) {
          result.push({key: keys[i], value: atts.properties[keys[i]]});
        }
        atts.property = result;
        delete atts.properties;
      }
      return atts;
    }
  });


  var PersistedResourcesCollection = PersistedCollection.extend({
    usePaths: true,
    model: PersistedResourceModel,

    initialize: function (unused, options) {
      options = options || {};
      options.serviceStub = options.serviceStub || new PersistedResourcesServiceStub();
      PersistedCollection.prototype.initialize.apply(this, arguments);
      this.path = options.path;
      this.owner = options.owner;
      this.property = options.property;
    },

    parse: function(response) {
      return response.persisted_resources;
    }
  });




  var PersistedCollectionsCollection = PersistedCollection.extend({
    usePaths: true,

    initialize: function (unused, options) {
      options = options || {};
      options.serviceStub = options.serviceStub || new PersistedCollectionsServiceStub();
      PersistedCollection.prototype.initialize.apply(this, arguments);
      this.path = options.path;
    },

    parse: function(response) {
      return response.persisted_collection;
    }
  });


  // options: channels, appid
  var Persisted = function (options) {
    this._persistedResourcesStub = new PersistedResourcesServiceStub();
    this._persistedCollectionsStub = new PersistedCollectionsServiceStub();
    this._persistedCollectionSchemaStub = new PersistedCollectionSchemaServiceStub();
    this.options = options;
  }

  _.extend(Persisted.prototype, {

    resources: function(path, properties) {
      var options = _.extend({}, this.options, {serviceStub: this._persistedResourcesStub,
                                               path: path,
                                               property: properties});
      // TODO: fetch restrictions
      return new PersistedResourcesCollection(null, options);
    },

    resource: function(path, properties) {
      var options = _.extend({}, this.options, {serviceStub: this._persistedResourcesStub,
                                               path: path});
      return new PersistedResourceModel(null, options);
    },

    collections: function(path, properties) {
      var options = _.extend({}, this.options, {serviceStub: this._persistedCollectionsStub,
                                               path: path});
      return new PersistedCollectionsCollection(null, options);
    },

    collection: function(path, properties) {
      var options = _.extend({}, this.options, {serviceStub: this._persistedCollectionsStub,
                                                path: path});
      return new PersistedResourceModel(null, options);
    },

    schema: function(path, properties) {
      var options = _.extend({}, this.options, {serviceStub: this._persistedCollectionSchemaStub,
                                                path: path});
      return new PersistedResourcesCollection(null, options);
    }

  });

  return Persisted;
});
